// function getEntity(snapshot: any, name: string, id: string) {
//   return snapshot.entities[name]?.collection[id];
// }

function serialize(snapshot: any) {
  const userId = snapshot.viewer.currentUser;
  const app = snapshot.app;
  const launchDate = app.launchDate;

  if (typeof userId === 'undefined') {
    return {
      app: {
        launchDate,
      },
    };
  }

  let currentUser = snapshot.entities.users.collection[userId];

  if (currentUser) {
    // Remove certain props from persisting for currentUser
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { posts, followers, following, ...restUserProps } =
      currentUser;

    currentUser = restUserProps;
  }

  return {
    app,
    viewer: {
      currentUser: userId,
    },
    entities: {
      users: {
        collection: { [userId]: currentUser },
      },
    },
  };
}

export default {
  serialize,
  migrate: (v: any) => v,
};
